(function iife(d) {
    /* activate a Panel */
    function activatePanel(id, tabcontainer) {
        const panels = tabcontainer.querySelectorAll('.TabPanel');
        const panel = d.getElementById(id);

        panels.forEach((paneltest) => {
            paneltest.classList.remove('TabPanel--active');
        });

        panel.classList.add('TabPanel--active');
    }

    /* activate a Tab and a corresponding Panel */
    function activateTab(tab, tabcontainer) {
        const actives = tabcontainer.querySelectorAll('.TabList__button--active');
        const id = tab.getAttribute('data-id');

        actives.forEach((active) => {
            active.classList.remove('TabList__button--active');
            active.setAttribute('tabindex', '-1');
            active.setAttribute('aria-selected', 'false');
        });

        tab.removeAttribute('tabindex');
        tab.classList.add('TabList__button--active');
        tab.setAttribute('aria-selected', 'true');
        activatePanel(id, tabcontainer);
    }

    function nextTab(button, tabcontainer) {
        const next = button.parentElement.nextElementSibling
            ? button.parentElement.nextElementSibling.querySelector('.TabList__button') : null;

        if (next) {
            activateTab(next, tabcontainer);
            next.focus();
        }
    }

    function prevTab(button, tabcontainer) {
        const prev = button.parentElement.previousElementSibling
            ? button.parentElement.previousElementSibling.querySelector('.TabList__button') : null;
        if (prev) {
            activateTab(prev, tabcontainer);
            prev.focus();
        }
    }

    /* add Listeners to tab */
    function addTabListeners(button, tabcontainer) {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            activateTab(button, tabcontainer);
        });

        button.addEventListener('keydown', (e) => {
            const code = e.keyCode;
            if (code === 37) {
                prevTab(button, tabcontainer);
            } else if (code === 39) {
                nextTab(button, tabcontainer);
            }
        });
    }

    const tabs = d.querySelectorAll('.Tab');
    function init() {
        /* add click function to tabs */
        tabs.forEach((tabcontainer) => {
            const buttons = tabcontainer.querySelectorAll('.TabList__button');
            buttons.forEach((button) => {
                button.setAttribute('tabindex', '-1');
                addTabListeners(button, tabcontainer);
            });

            /* activate the first Tab and Panel on init */
            const firsttab = tabcontainer.querySelector('.TabList__button');
            if (firsttab) {
                activateTab(firsttab, tabcontainer);
            }
        });
    }

    init();
}(document));
